import convertToOption from '../utils/convert-to-option';
import { API_URL } from '../utils/env';

export const timeGranularities = {
  DAY: 'day',
  MONTH: 'month',
};

export function productLabel(product) {
  return `${product.name} - ${product.business}, ${product.productGroup}`;
}

export const productFilterFields = [
  'name',
  'business',
  'productGroup',
  'externalName',
];

/*
  These are only the codes of products that have an influence on the code. There
  are many more products that are or have been sold.
*/
export const productCodes = {
  CCP: 'RM_CCP',
  M1_WEB: 'RM_WEB_M1',
  M1_WEB_LABEL: 'RM_WEB_LABEL_M1',
  M1_APP_LABEL: 'RM_APP_LABEL_M1',
  M2_WEB: 'RM_WEB_M2',
  RM_PS_FBIG: 'RM_PS_FBIG',
};

export const offerTypes = {
  BACKFILL: 'BACKFILL',
  CTO: 'CTO',
  GUARANTEED: 'GUARANTEED',
  HPTO: 'HPTO',
  M1TO: 'M1TO',
};

export const offerTypeOptions = Object.values(offerTypes).map(convertToOption);

export const propositions = {
  HOMEPAGE_TEASER_MID_FUNNEL: 'Homepage teaser - mid funnel',
  HOMEPAGE_TEASER_UPPER_FUNNEL: 'Homepage teaser - upper funnel',
};

export const propositionOptions =
  Object.values(propositions).map(convertToOption);

export const supportsvalidationCheck = product =>
  product === productCodes.CCP ||
  product === productCodes.M1_WEB_LABEL ||
  product === productCodes.M1_APP_LABEL;

export const offerTypesAllowingPropositions = [offerTypes.GUARANTEED];

export const isOfferTypeAllowingPropositions = offerType =>
  offerTypesAllowingPropositions.includes(offerType);

export const isOfferTypeHPTO = offerType => offerType === offerTypes.HPTO;
export const isOfferTypeM1TO = offerType => offerType === offerTypes.M1TO;

const { M1_APP_LABEL, M1_WEB_LABEL } = productCodes;
export const productswithExtraChecksForContentIds = [
  M1_APP_LABEL,
  M1_WEB_LABEL,
];

export const isContentIdsAllowed = (
  supportsContentIds,
  proposition,
  offerType,
  productCode,
) => {
  if (productswithExtraChecksForContentIds.includes(productCode))
    return (
      supportsContentIds &&
      (isOfferTypeHPTO(offerType) ||
        isOfferTypeM1TO(offerType) ||
        (isOfferTypeAllowingPropositions(offerType) &&
          proposition !== undefined))
    );
  return supportsContentIds;
};

export const isCollectionIdsAllowed = (
  supportsCollectionIds,
  supportsCreativeProductionBudgetBreakdown,
  proposition,
  offerType,
) =>
  (supportsCollectionIds || supportsCreativeProductionBudgetBreakdown) &&
  proposition !== propositions.HOMEPAGE_TEASER_UPPER_FUNNEL &&
  !isOfferTypeHPTO(offerType) &&
  !isOfferTypeM1TO(offerType);

export const OPERATIVE_SYSTEM_TYPES = {
  ccp: {
    label: 'Push to CCP',
    system: 'ccp',
    stagingLink: mapping =>
      `https://ccp-campaign-management-frontend.adtechlab-test.zalan.do/insertion-orders/${mapping.CCP_CampaignId}`,
    productionLink: mapping =>
      `https://ccp-campaign-management-frontend.adtechlab.zalan.do/insertion-orders/${mapping.CCP_CampaignId}`,
    successMessage: prodLabel => `Pushed ${prodLabel} to CCP`,
    errorMessage: prodLabel =>
      `Tried to push ${prodLabel} to CCP, but it failed`,
  },
  zmsAm: {
    label: 'Push to Ad Manager',
    system: 'zms_am',
    stagingLink: mapping =>
      `${API_URL}/campaign/${mapping.campaignId}/push_zms_am`,
    productionLink: mapping =>
      `${API_URL}/campaign/${mapping.campaignId}/push_zms_am`,
    successMessage: prodLabel => `Pushed ${prodLabel} to Ad Manager`,
    errorMessage: prodLabel =>
      `Tried to push ${prodLabel} to Ad Manager, but it failed`,
  },
  creativeFactory: {
    label: 'Push to Creative Factory',
    system: 'creative_factory',
    stagingLink: mapping =>
      `https://bowerbird.zms-media-engineering-test.zalan.do/#!/?searchTerm=${mapping.CF_InsertionOrderId}`,
    productionLink: mapping =>
      `https://bowerbird.zms-media-engineering.zalan.do/#!/?searchTerm=${mapping.CF_InsertionOrderId}`,
    successMessage: prodLabel => `Pushed ${prodLabel} to Creative Factory`,
    errorMessage: prodLabel =>
      `Tried to push ${prodLabel} to Creative Factory, but it failed`,
  },
  offsite: {
    label: 'Push to Offsite',
    system: 'offsite',
    successMessage: prodLabel => `Pushed ${prodLabel} to Offsite`,
    errorMessage: prodLabel =>
      `Tried to push ${prodLabel} to Offsite, but it failed`,
  },
  other: {
    system: 'other',
  },
};

export const getOperativeSystem = isDraftCampaignEnabled => {
  if (isDraftCampaignEnabled) {
    return {
      ...OPERATIVE_SYSTEM_TYPES,
      ccp: {
        label: 'Push to AdManager as Draft',
        system: 'zms_am',
        successMessage: prodLabel =>
          `Pushed ${prodLabel} to AdManager as Draft`,
        errorMessage: prodLabel =>
          `Tried to push ${prodLabel} to AdManager as Draft, but it failed`,
      },
    };
  }

  return OPERATIVE_SYSTEM_TYPES;
};
